module.exports = __webpack_public_path__ + "img/badge-list-thumb-007.ca1dcd56.png";